import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../../../../../shared/store/redux/auth-actions';
import Text from '../../../../../../shared/components/features/text/Text';
import Icon from '../../../../../../shared/components/ui/icons/Icon';
import iconsList from '../../../../../../shared/components/ui/icons/iconsList';
import logo from '../../../../../../assests/notAuth/LogoMobile.png';
import classes from './InfoPartOne.module.css';


const InfoPartOne = () => {

    const { texts } = useSelector(state => state.translate);
    const dispatch = useDispatch()

    return (
        <div className={classes.InfoPartOneWrapper}>
            <img className={classes.Logo} src={logo} alt='' />
            <div className={classes.InfoPartOne}>
                <div className={classes.TitleWrapper}>
                    <div className={classes.Title}>
                        <Text className={classes.TitleSimple}>{`${texts.fromEachPlace ?? ""},`}</Text>
                        <Text className={classes.TitleRegular}>{`${texts.inEachTime ?? ""},`}</Text>
                    </div>
                    <Text className={classes.TitleBold}>{`${texts.forYou ?? ""}.`}</Text>
                </div>
                <div className={classes.DescriptionWrapper}>
                    <Text className={classes.Description}>{texts.topBannerDescription}</Text>
                    <div className={classes.PrimaryBtnWrapper}>
                        <button className={classes.Btn} onClick={() => dispatch(login())} >
                            {texts.topBannerBtnText}
                            <span className={classes.ArrowsIcon}>
                                <Icon name={iconsList.arrows} size="100%" color="#FFF" />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default InfoPartOne;